import { UserX } from "lucide-react";
import { brand } from "@/config/brand";
import { useClientAuth } from "@/auth/ClientAuthProvider";
import { Button } from "@/components/ui/button";

export function NoAccount({ message, email }: { message: string; email: string | null }) {
  const { signOut } = useClientAuth();
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-lg flex-col justify-center px-5 pb-safe pt-safe">
      <img src={brand.logoPath} alt={brand.name} className="mb-10 h-9 w-auto self-start" />
      <section className="rounded-xl border border-line bg-card p-6 shadow-card">
        <UserX className="mb-4 h-10 w-10 text-muted-foreground" />
        <h1 className="text-xl font-bold text-ink">No account for this email yet</h1>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
        {email ? (
          <p className="mt-3 text-sm">
            Signed in as <span className="font-semibold text-ink">{email}</span>
          </p>
        ) : null}
        <div className="mt-6 grid gap-2">
          <Button asChild variant="secondary">
            <a href={brand.supportPhoneHref}>Call {brand.supportPhone}</a>
          </Button>
          <Button variant="ghost" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </section>
    </main>
  );
}
